import { ServiceRegistry } from "@/services/ServiceRegistry";
import { invoiceProvider } from "@/services/invoiceGeneration";
import type { Receivable } from "@/services/invoiceGeneration";

/** The file name a downloaded copy gets — a draft says so in its name, never on the document (screens.md Q2). */
export function invoiceDownloadName(invoice: Pick<Receivable, "number" | "status">): string {
  return invoice.status === "draft" ? `Faktura-${invoice.number}-utkast.pdf` : `Faktura-${invoice.number}.pdf`;
}

/**
 * Saves the invoice's PDF under `invoiceDownloadName`, rendering a draft's first if it has
 * none yet (EC8). Fetched as a blob so the saved file gets our name — a cross-origin
 * link's `download` attribute is ignored by the browser.
 */
export async function downloadInvoicePdf(invoice: Receivable, knownPath?: string): Promise<void> {
  const path = knownPath ?? invoice.pdfPath ?? await invoiceProvider.ensureDraftPdf(invoice.id);
  const url = await ServiceRegistry.getInvoiceService().getInvoiceFileUrl(path);
  if (!url) throw new Error("no signed URL for the invoice PDF");
  const blob = await (await fetch(url)).blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = invoiceDownloadName(invoice);
  a.click();
  URL.revokeObjectURL(objectUrl);
}

